// removed by extract-text-webpack-plugin
module.exports = {"letter-box":"letter-box___1PWL2","letter-box-flex":"letter-box-flex___2YhaG center___2iqBf","letter-box-label":"letter-box-label___2xPQn","show-letter-button":"show-letter-button___2B6vL","company-letter-slidedown":"company-letter-slidedown___8PBdZ","company-letter-blockquote":"company-letter-blockquote___1wEVL h4___kHWTn","take-action-icons":"take-action-icons___wNUdy center___2iqBf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AmazonVanguardLetters/AmazonVanguardLetters.css
// module id = 253
// module chunks = 0